module.exports = __webpack_public_path__ + "img/galerie-20.4d712d2f.jpg";